<template>
    <el-col :span="spanAlarm" class="alarm-card-container">
        <div
            :class="{ 'active-alarm-card' : active, 'inactive-alarm-card' : !active}"
            class="alarm-card"
        >
            <div class="alarm-icon">
                <i class="el-icon-message-solid offset-img"></i>
            </div>
            <div class="alarm-content">
                <div>
                    <div class="bold">{{ name }}</div>
                    <vue-markdown :source="message"></vue-markdown>
                </div>
                <hr>
                <div>
                    <el-row>
                        <el-col :span="24">
                            <div class="small">{{ triggerDateText }}</div>
                            <span :class="{ 'bold' : active}">{{ humanizeLastSeenDate(modificationDate) }}</span>
                            <div class="small">Status</div>
                            <span
                                v-if="level"
                                :class="[`${level.toLowerCase()}`, 'bold']"
                            >{{level}}</span>
                        </el-col>
                        <el-col v-if="correctiveActionMessage && active" :span="24">
                            <div class="small">{{ getVerbose('alarm_details_title') }}</div>
                            <div>{{ correctiveActionMessage }}</div>
                        </el-col>
                        <el-col
                            v-if="relatedUrl && active" :span="24" class="button-resource">
                            <a :href="getCorrectRelatedUrl(relatedUrl)">
                                <el-button>{{ getVerbose('alarm_redirection_button') }}</el-button>
                            </a>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </el-col>
</template>

<script>
import moment from 'moment';
import {mapGetters} from 'vuex';
import VueMarkdown from 'vue-markdown';
export default {

    components: {
        VueMarkdown
    },

    props: {
        active: {
            type: Boolean,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        modificationDate: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: true,
        },
        correctiveActionMessage: {
            type: String,
            required: true,
        },
        relatedUrl: {
            type: String,
            required: true,
        },
        level: {
            type: String,
            required: false,
        },
    },
    computed: {
        ...mapGetters('fundation', [
            'getCorrectRelatedUrl',
            'getVerbose',
            'currentLang'
        ]),

        spanAlarm() {
            if (window.innerWidth <= 768) {
                return 24;
            }
            return this.active ? 24 : 12;
        },

        triggerDateText() {
            return this.active ? this.getVerbose('alarm_last_active_time') : this.getVerbose('alarm_last_trigger_time');
        },
    },
    methods: {

        humanizeLastSeenDate(date) {

            let ms = moment().diff(moment(date));
            let d = moment.duration(ms);
            let text = '';

            // permet de copier toutes les clés éxepté seconds et milliseconds dans durationData (cré aussi les variables seconds, milliseconds mais on ne les utilise pas)
            let {seconds, milliseconds, ...durationData} = d._data;
            let {minutes, hours, days, months, years} = d._data;
            let toSoon = Object.values(durationData).every((value) => value === 0);

            if(toSoon) {
                text = this.getVerbose('moment_close_time');
            } else {
                if (years > 0 || months > 0 || days > 0) {
                    let dayCount = moment().diff(moment(date),  'days');
                    text = dayCount === 1 ? this.getVerbose('moment_one_day') : dayCount + this.getVerbose('moment_days');
                } else if (hours > 0) {
                    text = hours === 1 ? this.getVerbose('moment_one_hour') : hours + this.getVerbose('moment_hours');
                } else if (minutes > 0) {
                    text = minutes === 1 ? this.getVerbose('moment_one_minute') : minutes + this.getVerbose('moment_minutes');
                }
            }
            if (this.currentLang === 'fr') {
                if (text === this.getVerbose('moment_close_time')) {
                    // small adjustemet for the french language
                    return text.replace('Il y a p', 'P');
                }
                return this.active ? text : this.getVerbose('moment_ago') + text;
            }
            else if (this.currentLang === 'en') {
                return this.active ? text : text + this.getVerbose('moment_ago');
            }

        },
    },
};
</script>

<style lang="scss">
.alarm-card-container {
    .active-alarm-card {
        border-left: 10px solid #f78888 !important;
    }

    .inactive-alarm-card {
        border-left: 10px solid #66B1FF !important;
    }

    .alarm-card {

        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        padding: 10px 25px 10px 0px;
        border: 1px solid #eee;
        border-radius: 5px;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);

        hr {
            margin: 15px 0px;
        }


        .alarm-icon {
            width: 11em;
            height: 12em;
            overflow: hidden;
            .offset-img {
                font-size: 12em;
                position: relative;
                left: -40px;
                color: #e6e6e6;
            }
        }

        .alarm-content {
            width: 100%;
            .bold {
                font-weight: 600;
            }
            .small {
                font-size: smaller;
            }
            .button-resource {
                display: flex;
                justify-content: flex-end;
            }

            .alarm-message {
                margin: 10px 0px;
            }
            .ok {
                color: #67c23a;
            }
            .warning {
                color: #e6a23c;
            }
            .critical {
                color: #f56c6c;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/alarms/alarmItem.vue